
    
    <template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-if="!loading" my-2>
            <form @submit.prevent="update_user_reports" autocomplete="off">
                <v-layout row wrap>
                    

            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="reports" v-model="user_reports.report_id" outlined  item-text="report_id"
                            item-value="report_id" :return-object="false" :label="$store.getters.lang.data.report_id">
                        </v-select>
                        </v-flex>
            

            <v-flex xs12 lg2 xl2 md3 sm4>
            <v-select class="mx-1" clearable rounded filled :items="users" v-model="user_reports.user_id" outlined  item-text="user_id"
                            item-value="user_id" :return-object="false" :label="$store.getters.lang.data.user_id">
                        </v-select>
                        </v-flex>
            
        <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field rounded type="date" v-model="user_reports.report_date" :label="$store.getters.lang.data.report_date"
                            outlined class="mx-1" filled  required>
                        </v-text-field>
                    </v-flex>
        

    
    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn color="primary" rounded class="mx-1"  type="submit" x-large>{{$store.getters.lang.data.update_btn}}</v-btn>
                    </v-flex>    
                </v-layout>
            </form>
        </v-container>
        
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>

<script>
    import controller from './../../controller/user_reports'
    export default {
        data() {
            return {
                user_reports: {},
                id: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },

            }
        },
        computed: {
            
                    reports (){
                        return this.$store.getters.reports
                    },
                    
                    users (){
                        return this.$store.getters.users
                    },
                    
            
        },
        methods: {
            get_user_reports() {
                this.loading = true
                controller.getOne(this.id).then(r =>{
                    this.user_reports = r.data.row
                    this.loading = false
                }).catch(e =>{
                    console.log(e);
                })
            },
            update_user_reports() {
                controller.update_user_reports(this.user_reports).then(r => {
                    if (r.data) {
                        this.snackbar = {
                            value: true,
                            text: 'Updated',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Not Updated',
                            color: 'error'
                        }
                    }
                })
            },
            
        },
        mounted() {
            this.id = this.$route.params.id
            this.get_user_reports()
        },
    }
</script>
    
    